import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import Body from "./Body.js";
export const Body1 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Body, _extends({
  ref: ref,
  level: 1
}, props)));
export const Body2 = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Body, _extends({
  ref: ref,
  level: 2
}, props)));